import { Button, Grid, Input } from "@chakra-ui/core";
import React, { useState } from "react";

function SearchBar({ setValue }) {
  const [search, setSearch] = useState("");
  const handleClick = () => {
    setValue(search.toLowerCase());
  };
  // const handleSearch = (value) => {
  //     if(value.length === 0){
  //         setSearch('');
  //         setValue('');
  //     } else {
  //         setSearch(value);
  //         setValue(search.toLowerCase());

  //     }
  // }
  return (
    <Grid
      margin="0 auto"
      width={{ lg: "32.5rem", md: "70%", sm: "100%" }}
      padding={{ lg: "0 0 2.5rem", md: "0", sm: "0" }}
      templateColumns="repeat(auto-fit, minmax(150px, 1fr))"
      marginY="10"
      gap="0.5em"
    >
      <Input
        boxShadow="lg"
        gridColumn={{ lg: "1 / span 2", md: "1 / span 2", sm: "1" }}
        variant="outline"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search your query here 👇🏼"
      />
      <Button
        boxShadow="md"
        variantColor="green"
        onClick={handleClick}
        leftIcon="search"
        paddingX="2em"
      >
        Search
      </Button>
    </Grid>
  );
}

export default SearchBar;
